import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import {
  TaskExecution,
  useUpdateTaskExecutionMutation,
  UserItem,
} from "shared/api";

interface Props {
  open: boolean;
  record: TaskExecution | null;
  users: UserItem[];
  onClose: () => void;
}

export const UserEditModal: React.FC<Props> = ({
  open,
  record,
  users,
  onClose,
}) => {
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [updateTaskExecution, { isLoading }] = useUpdateTaskExecutionMutation();

  useEffect(() => {
    if (record?.user != null) {
      if (typeof record.user === "number") {
        setSelectedUserId(record.user);
      } else if ("id" in record.user && typeof record.user.id === "number") {
        setSelectedUserId(record.user.id);
      }
    }
  }, [record]);

  const handleOk = async () => {
    if (!record || selectedUserId == null) return;

    await updateTaskExecution({
      id: record.id,
      data: { user: selectedUserId },
    });

    onClose();
  };

  return (
    <Modal
      title="Update User"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={isLoading}
      okText="Save"
      okButtonProps={{
        className: "bg-green-600 hover:bg-green-700 text-white",
      }}
    >
      <Select
        style={{ width: "100%" }}
        value={selectedUserId ?? undefined}
        onChange={(val) => setSelectedUserId(val)}
        options={users.map((u) => ({ label: u.username, value: u.id }))}
        showSearch
        placeholder="Select a user"
        optionFilterProp="label"
      />
    </Modal>
  );
};
